import { action } from 'typesafe-actions';
import { User } from '../../../types/apiResponse/user';
import { IntegrationModel } from '../../../types/apiResponseTypes';
import { AuthResponseData } from '../../../types/auth';

type SignInRequestProps = {
  login: string;
  password: string;
};

type SignInByTokenRequestProps = {
  token: string;
  urlPath: string;
};

export type UserProps = User;

export type IntegrationModelsProp = IntegrationModel[] | [];

type RefreshSuccessProps = {
  newToken: string;
};

type RefreshRequestProps = {
  accessToken: string;
};

export function signInRequest({ login, password }: SignInRequestProps) {
  return action('@auth/SIGN_IN_REQUEST', {
    login,
    password,
  });
}

export function signInByTokenRequest({ token, urlPath }: SignInByTokenRequestProps) {
  return action('@auth/SIGN_IN_BY_TOKEN_REQUEST', {
    token,
    urlPath,
  });
}

export function signInSuccess(authResponseData: AuthResponseData) {
  let expirationDate = Date.now();

  if (authResponseData.expires_in === null || authResponseData.expires_in === 0) {
    // Se nao tem data de validade para o token, entao define 1 mes
    const date = new Date(expirationDate);
    date.setMonth(date.getMonth() + 1);
    expirationDate = date.getTime();
  } else {
    // subtrai 3 minutos do tempo de expiracao e converter em milisegundos
    const newExpiresIn = (authResponseData.expires_in - 3) * 60000;
    // Adiciona o novo tempo de expiracao a data atual
    expirationDate += newExpiresIn;
  }

  return action('@auth/SIGN_IN_SUCCESS', {
    token: authResponseData.token,
    authType: authResponseData.authType,
    expires_in: authResponseData.expires_in,
    user: authResponseData.user,
    expirationDate: expirationDate,
  });
}

export function setIntegrationModels(IntegrationModels: IntegrationModelsProp) {
  return action('@auth/SET_INTEGRATION_MODELS', {
    IntegrationModels,
  });
}

export function logoutRequest() {
  return action('@auth/LOGOUT_REQUEST');
}

export function logoutSuccess() {
  return action('@auth/LOGOUT_SUCCESS');
}

export function signInFailure() {
  return action('@auth/SIGN_IN_FAILURE');
}

export function refreshRequest({ accessToken }: RefreshRequestProps) {
  return action('@auth/REFRESH_REQUEST', {
    accessToken,
  });
}

export function refreshSuccess({ newToken }: RefreshSuccessProps) {
  return action('@auth/REFRESH_SUCCESS', {
    token: newToken,
  });
}

export function refreshFailure() {
  return action('@auth/REFRESH_FAILURE');
}

export function setStatusLoadingLogin(status: boolean) {
  return action('@auth/SET_STATUS_LOADING_LOGIN', {
    status,
  });
}
